// extracted by mini-css-extract-plugin
export default {"LoaderContainer":"FullPageLoader_LoaderContainer__6UTcl","Spinner":"FullPageLoader_Spinner__J37It","spin":"FullPageLoader_spin__EFVU8"};